import { css } from 'lit';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var styles = css`@charset "UTF-8";
.accordion {
  --bsi-accordion-active-bg: var(
    --bsi-color-background-primary
  );
  --bsi-accordion-active-color: var(
    --bsi-color-text-primary-active
  );
  --bsi-accordion-background: var(--bsi-page-background);
  --bsi-accordion-border-color: var(--bsi-color-border-subtle);
  --bsi-accordion-border-radius: var(--bsi-radius-smooth);
  --bsi-accordion-border-width: 0;
  --bsi-accordion-body-padding-x: var(--bsi-spacing-m);
  --bsi-accordion-body-padding-y: var(--bsi-spacing-s);
  --bsi-accordion-btn-active-icon: escape-svg(url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='rgb(0, 91.8, 183.6)'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>"));
  --bsi-accordion-btn-bg: var(--bsi-accordion-background);
  --bsi-accordion-btn-color: var(--bsi-color-text-primary);
  --bsi-accordion-btn-focus-border-color: hsl(210, 17%, 44%);
  --bsi-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(0, 102, 204, 0.25);
  --bsi-accordion-btn-icon: escape-svg(url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='hsl(0, 0%, 10%)'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>"));
  --bsi-accordion-btn-icon-transform: rotate(-180deg);
  --bsi-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bsi-accordion-btn-icon-width: 1.25rem;
  --bsi-accordion-btn-line-height: var(--bsi-font-leading-1);
  --bsi-accordion-btn-padding-x: var(--bsi-spacing-m);
  --bsi-accordion-btn-padding-y: var(--bsi-spacing-s);
  --bsi-accordion-color: var(--bsi-color-text-base);
  --bsi-accordion-inner-border-radius: var(--bsi-radius-smooth);
  --bsi-accordion-item-border-width: 1px;
  --bsi-accordion-transition: var(--bsi-transition-instant);
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bsi-accordion-btn-padding-y) var(--bsi-accordion-btn-padding-x);
  border: 0;
  line-height: var(--bsi-accordion-btn-line-height);
  background-color: var(--bsi-accordion-btn-bg);
  color: var(--bsi-accordion-btn-color);
  text-align: left;
  overflow-anchor: none;
  border-radius: 0;
  transition: var(--bsi-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  background-color: var(--bsi-accordion-active-bg);
  color: var(--bsi-accordion-active-color);
}
.accordion-button:not(.collapsed)::after {
  background-image: var(--bsi-accordion-btn-active-icon);
  transform: var(--bsi-accordion-btn-icon-transform);
}
.accordion-button::after {
  content: "";
  flex-shrink: 0;
  width: var(--bsi-accordion-btn-icon-width);
  height: var(--bsi-accordion-btn-icon-width);
  margin-left: auto;
  background-image: var(--bsi-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bsi-accordion-btn-icon-width);
  transition: var(--bsi-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  border-color: var(--bsi-accordion-btn-focus-border-color);
  outline: 0;
  box-shadow: var(--bsi-accordion-btn-focus-box-shadow);
}

.accordion-flush .accordion-collapse {
  border-width: 0;
}
.accordion-flush .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush .accordion-item .accordion-button, .accordion-flush .accordion-item .accordion-button.collapsed {
  border-radius: 0;
}

/* stylelint-disable-next-line no-duplicate-selectors */
.accordion {
  border-left-width: var(--bsi-accordion-border-width);
  border-right-width: var(--bsi-accordion-border-width);
  border-top-width: var(--bsi-accordion-border-width);
  border-bottom: 0;
  border-color: var(--bsi-accordion-border-color);
  border-style: solid;
}
.accordion .accordion {
  border-left: 1px solid var(--bsi-accordion-border-color);
  border-right: 1px solid var(--bsi-accordion-border-color);
}
.accordion.accordion-background-active .accordion-header .accordion-button[aria-expanded=true] {
  background-color: var(--bsi-color-background-primary);
  color: var(--bsi-color-text-inverse);
}
.accordion.accordion-background-active .accordion-header .accordion-button[aria-expanded=true]:before {
  color: var(--bsi-color-text-inverse);
}
.accordion.accordion-background-active .accordion-header .accordion-button[aria-expanded=true]:after {
  content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' x='0px' y='0px' viewBox='0 0 24 24' %3E%3Cg%3E%3Cpath fill='url-friendly-color(hsl(0, 0%, 100%))' d='M12,10.3l4.8,4.8c0.3,0.3,0.8,0.3,1.1,0c0.3-0.3,0.3-0.8,0-1c0,0,0,0,0,0l-4.8-4.8c-0.6-0.6-1.5-0.6-2.1,0L6.2,14c-0.3,0.3-0.3,0.8,0,1c0,0,0,0,0,0c0.3,0.3,0.8,0.3,1.1,0L12,10.3z'/%3E%3C/g%3E%3C/svg%3E");
}
.accordion.accordion-background-hover .accordion-header .accordion-button:hover {
  background-color: var(--bsi-color-background-primary);
  color: var(--bsi-color-text-inverse);
}
.accordion.accordion-background-hover .accordion-header .accordion-button:hover:before {
  color: var(--bsi-color-text-inverse);
}
.accordion.accordion-background-hover .accordion-header .accordion-button:hover:after {
  content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' x='0px' y='0px' viewBox='0 0 24 24' %3E%3Cg%3E%3Cpath fill='url-friendly-color(hsl(0, 0%, 100%))' d='M12,10.3l4.8,4.8c0.3,0.3,0.8,0.3,1.1,0c0.3-0.3,0.3-0.8,0-1c0,0,0,0,0,0l-4.8-4.8c-0.6-0.6-1.5-0.6-2.1,0L6.2,14c-0.3,0.3-0.3,0.8,0,1c0,0,0,0,0,0c0.3,0.3,0.8,0.3,1.1,0L12,10.3z'/%3E%3C/g%3E%3C/svg%3E");
}
.accordion.accordion-left-icon .accordion-header .accordion-button:after {
  content: none;
}
.accordion.accordion-left-icon .accordion-header .accordion-button:before {
  content: "-";
  width: 1.5rem;
  margin: 0 var(--bsi-spacing-s) 0 0;
  float: left;
  overflow: hidden;
  font-family: var(--bsi-font-serif);
  font-size: var(--bsi-heading-5-font-size);
  font-weight: 300;
  line-height: var(--bsi---bsi-accordion-btn-line-height);
  transform: none;
}
.accordion.accordion-left-icon .accordion-header .accordion-button[aria-expanded=false]:before {
  content: "+";
}

.accordion-item {
  border-top: var(--bsi-accordion-item-border-width) solid var(--bsi-accordion-border-color);
  border-bottom: var(--bsi-accordion-item-border-width) solid var(--bsi-accordion-border-color);
  background-color: var(--bsi-accordion-background);
  color: var(--bsi-accordion-color);
}
.accordion-item:first-of-type {
  border-top-left-radius: var(--bsi-accordion-border-radius);
  border-top-right-radius: var(--bsi-accordion-border-radius);
}
.accordion-item:first-of-type .accordion-button {
  border-top-left-radius: var(--bsi-accordion-inner-border-radius);
  border-top-right-radius: var(--bsi-accordion-inner-border-radius);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: var(--bsi-accordion-border-radius);
  border-bottom-left-radius: var(--bsi-accordion-border-radius);
}
.accordion-item:last-of-type .accordion-button.collapsed {
  border-bottom-right-radius: var(--bsi-accordion-inner-border-radius);
  border-bottom-left-radius: var(--bsi-accordion-inner-border-radius);
}
.accordion-item:last-of-type .accordion-collapse {
  border-bottom-right-radius: var(--bsi-accordion-border-radius);
  border-bottom-left-radius: var(--bsi-accordion-border-radius);
}
.accordion-item:first-of-type, .accordion-item:last-of-type {
  border-radius: 0;
}
.accordion-item:first-of-type .accordion-button, .accordion-item:last-of-type .accordion-button {
  border-radius: 0;
}

.accordion-header {
  position: relative;
  margin-bottom: 0;
}
.accordion-header .accordion-button {
  width: 100%;
  border: 0;
  background-color: transparent;
  box-shadow: none;
  color: var(--bsi-accordion-btn-color);
  font-size: var(--bsi-body-font-size);
  font-weight: var(--bsi-font-weight-solid);
  cursor: pointer;
}
.accordion-header .accordion-button:hover {
  background: none;
  text-decoration: underline;
}
.accordion-header .accordion-button:hover:after {
  text-decoration: none;
}
.accordion-header .accordion-button:active, .accordion-header .accordion-button:hover, .accordion-header .accordion-button:focus {
  border-top-color: var(--bsi-accordion-border-color);
}
.accordion-header .accordion-button:not(.collapsed):after {
  transform: scaleY(1);
}
.accordion-header .accordion-button:not(.collapsed):hover:before, .accordion-header .accordion-button[aria-expanded=true]:hover:before {
  text-decoration: none;
}
.accordion-header .accordion-button:after {
  content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' x='0px' y='0px' viewBox='0 0 24 24' %3E%3Cg%3E%3Cpath fill='url-friendly-color(hsl(210, 100%, 40%))' d='M12,10.3l4.8,4.8c0.3,0.3,0.8,0.3,1.1,0c0.3-0.3,0.3-0.8,0-1c0,0,0,0,0,0l-4.8-4.8c-0.6-0.6-1.5-0.6-2.1,0L6.2,14c-0.3,0.3-0.3,0.8,0,1c0,0,0,0,0,0c0.3,0.3,0.8,0.3,1.1,0L12,10.3z'/%3E%3C/g%3E%3C/svg%3E");
  width: 1.5rem;
  height: auto;
  float: right;
  background-image: none;
  color: var(--bsi-accordion-btn-color);
  line-height: 0.1rem;
  transform: scaleY(-1);
  transition: transform 0.3s;
}

.accordion-body {
  padding: var(--bsi-accordion-body-padding-y) var(--bsi-accordion-body-padding-x);
  font-size: var(--bsi-body-font-size);
  line-height: var(--bsi-body-line-height);
}
.accordion-body .accordion-header button[aria-expanded=true]:before {
  width: 0;
  height: 0;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: hsla(0, 0%, 0%, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: 1px solid;
  opacity: 0.25;
}

p {
  margin-top: 0;
  margin-bottom: var(--bsi-paragraph-spacing);
}

abbr[title] {
  text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: var(--bsi-spacing-s);
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: var(--bsi-spacing-l);
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: var(--bsi-spacing-s);
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: var(--bsi-font-weight-strong);
}

dd {
  margin-bottom: var(--bsi-spacing-xxs);
  margin-left: 0;
}

blockquote {
  margin: 0 0 var(--bsi-spacing-s);
}

sub,
sup {
  position: relative;
  font-size: var(--bsi-font-size-1);
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: var(--bsi-color-link);
  text-decoration: underline;
  text-decoration-skip-ink: auto;
  text-underline-offset: 2px;
}
a:hover {
  color: var(--bsi-color-link-hover);
  cursor: pointer;
}

pre,
code,
kbd,
samp {
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: var(--bsi-paragraph-spacing);
  overflow: auto;
}
pre code {
  word-break: normal;
}

a > code {
  color: inherit;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: hsl(210, 17%, 44%);
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: textfield;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

body {
  font-family: var(--bsi-font-sans);
}

p,
ul,
ol,
dl {
  font-size: var(--bsi-body-font-size);
  line-height: var(--bsi-body-leading);
}

caption,
figcaption {
  font-size: var(--bsi-caption-font-size);
  line-height: var(--bsi-caption-leading);
}

b,
strong {
  font-weight: var(--bsi-font-weight-strong);
}

mark,
code {
  padding: 0 var(--bsi-spacing-3xs);
}

mark {
  background-color: var(--bsi-highlight-background);
}

pre,
code,
kbd,
samp {
  border-radius: var(--bsi-radius-smooth);
  font-family: var(--bsi-font-mono);
}

ins,
del {
  position: relative;
  display: flex;
  align-items: center;
  padding: var(--bsi-spacing-3xs) var(--bsi-spacing-m);
  font: var(--bsi-body-font-size);
  text-decoration: none;
}

ins {
  background-color: var(--bsi-ins-background);
  text-decoration: none;
}

del {
  background-color: var(--bsi-del-background);
}

del::before,
ins::before {
  position: absolute;
  left: 0.5rem;
}

del::before {
  content: "−";
}

ins::before {
  content: "+";
}

kbd {
  margin: 0 2px;
  padding: 2px var(--bsi-spacing-3xs);
  border: var(--bsi-border-base) solid var(--bsi-color-border-subtle);
  background-color: var(--bsi-color-background-secondary-lighter);
  box-shadow: var(--bsi-elevation-low), 0 2px 0 0 hsla(255, 0%, 100%, 0.7) inset;
  color: var(--bsi-color-text-secondary);
  font-size: var(--bsi-font-size-1);
  font-weight: var(--bsi-font-weight-solid);
  white-space: nowrap;
}
kbd kbd {
  padding: 0;
  font-size: var(--bsi-code-font-size);
}

small,
.small {
  font-size: var(--bsi-caption-font-size);
}

.x-small {
  font-size: var(--bsi-font-size-1);
}

h1,
.h1 {
  font-size: var(--bsi-heading-1-font-size);
}

h2,
.h2 {
  font-size: var(--bsi-heading-2-font-size);
}

h3,
.h3 {
  font-size: var(--bsi-heading-3-font-size);
}

h4,
.h4 {
  font-size: var(--bsi-heading-4-font-size);
}

h5,
.h5 {
  font-size: var(--bsi-heading-5-font-size);
}

h6,
.h6 {
  font-size: var(--bsi-heading-6-font-size);
}

h1,
.h1,
h2,
.h2,
h3,
.h3,
h4,
.h4,
h5,
.h5,
h6,
.h6 {
  margin-top: 0;
  margin-bottom: var(--bsi-heading-spacing);
  line-height: var(--bsi-heading-leading);
}
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + h1, p + h1,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + .h1,
p + .h1,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + h2,
p + h2,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + .h2,
p + .h2,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + h3,
p + h3,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + .h3,
p + .h3,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + h4,
p + h4,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + .h4,
p + .h4,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + h5,
p + h5,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + .h5,
p + .h5,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + h6,
p + h6,
:is(h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) + .h6,
p + .h6 {
  padding-top: var(--bsi-spacing-s);
}

h1,
h2,
h3,
.h1,
.h2,
.h3 {
  font-weight: var(--bsi-heading-font-weight);
}

h4,
h5,
h6,
.h4,
.h5,
.h6 {
  font-weight: var(--bsi-heading-font-weight-weak);
}

h1,
.h1,
.display-1 {
  letter-spacing: -1px;
}

.font-serif {
  font-family: var(--bsi-font-serif) !important;
}

.font-sans-serif {
  font-family: var(--bsi-font-sans) !important;
}

.font-monospace {
  font-family: var(--bsi-font-mono) !important;
}

.display-1 {
  font-size: var(--bsi-display-font-size);
  font-weight: var(--bsi-heading-font-weight);
  line-height: var(--bsi-heading-leading);
}

.lead {
  font-size: var(--bsi-lead-font-size);
  font-weight: var(--bsi-lead-font-weight);
  line-height: var(--bsi-lead-leading);
}

blockquote,
.blockquote {
  margin: var(--bsi-spacing-m) 0;
  margin-left: var(--bsi-spacin-inline-xs);
  padding: var(--bsi-spacing-s);
  border-left: var(--bsi-border-thick) solid var(--bsi-border-color-secondary);
  font-size: var(--bsi-body-font-size);
  line-height: var(--bsi-body-leading);
}
blockquote > :last-child,
.blockquote > :last-child {
  margin-bottom: 0;
}
blockquote.text-end,
.blockquote.text-end {
  margin-right: var(--bsi-spacin-inline-xs);
  border-right: var(--bsi-border-thick) solid var(--bsi-border-color-secondary);
}
blockquote.text-center, blockquote.text-end, blockquote.blockquote-simple,
.blockquote.text-center,
.blockquote.text-end,
.blockquote.blockquote-simple {
  margin-left: 0;
  border-right: none;
  border-left: none;
}
blockquote.text-center, blockquote.blockquote-simple,
.blockquote.text-center,
.blockquote.blockquote-simple {
  padding: 0;
}
blockquote.blockquote-simple,
.blockquote.blockquote-simple {
  font-style: italic;
}
blockquote.blockquote-card,
.blockquote.blockquote-card {
  margin-left: 0;
  padding: var(--bsi-spacing-m);
  background-color: var(--bsi-color-background-inverse);
  box-shadow: var(--bsi-elevation-low);
}
blockquote.blockquote-card .blockquote-footer,
.blockquote.blockquote-card .blockquote-footer {
  font-size: inherit;
}
blockquote.blockquote-card .blockquote-footer:before,
.blockquote.blockquote-card .blockquote-footer:before {
  content: none;
}
blockquote.blockquote-card.dark,
.blockquote.blockquote-card.dark {
  border-left: none;
  background-color: var(--bsi-color-background-primary);
  color: var(--bsi-color-text-inverse);
}
blockquote.blockquote-card.dark .blockquote-footer,
.blockquote.blockquote-card.dark .blockquote-footer {
  color: var(--bsi-color-text-inverse);
}

.blockquote-footer {
  margin-top: 0;
  margin-bottom: var(--bsi-spacing-s);
  color: var(--bsi-color-text-secondary);
  font-size: var(--bsi-label-font-size);
}
.blockquote-footer::before {
  content: "— ";
}
.bg-dark .blockquote-footer {
  color: var(--bsi-color-text-muted);
}

.initialism {
  font-size: var(--bsi-label-font-size-s);
  text-transform: uppercase;
}

:host {
  --bsi-accordion-btn-icon-width: 1.5rem;
}

:host([left-icon]) {
  --bsi-accordion-btn-icon-width: 1.25rem;
}

:host([background-active]) .accordion-header .accordion-button:not(.collapsed) {
  background-color: var(--bsi-color-background-primary);
  color: var(--bsi-color-text-inverse);
}

:host([background-hover]) .accordion-header .accordion-button:hover {
  background-color: var(--bsi-color-background-primary);
  color: var(--bsi-color-text-inverse);
}
:host([background-hover]) .accordion-header .accordion-button:hover it-icon::part(icon) {
  --bsi-icon-primary: var(--bsi-color-text-inverse);
}

:host(:not(:first-of-type)) .accordion-item {
  border-top: 0;
}

:host([left-icon]) .accordion-header .accordion-button {
  justify-content: flex-start;
}

it-accordion-item {
  display: block;
  width: 100%;
}

it-icon::part(icon) {
  width: var(--bsi-accordion-btn-icon-width);
  height: var(--bsi-accordion-btn-icon-width);
  fill: currentColor;
}

.accordion-button {
  display: flex !important;
  align-items: center;
  justify-content: space-between;
  border-radius: 0;
  color: var(--accordion-button-color, inherit);
  font-family: var(--bsi-font-sans);
  text-align: left;
  --bsi-accordion-inner-border-radius: 0;
}
.accordion-button::after {
  content: none !important;
}
.accordion-button:focus-visible {
  z-index: 3;
  border-color: #000 !important;
  box-shadow: var(--bsi-accordion-btn-focus-box-shadow);
  box-shadow: 0 0 0 2px var(--bsi-color-border-inverse), 0 0 0 5px var(--bsi-color-outline-focus) !important;
  outline: 3px solid rgba(0, 0, 0, 0) !important;
  outline-offset: 3px !important;
}
.accordion-button span {
  flex: 1;
}

.accordion-icon {
  flex-shrink: 0;
  margin-left: auto;
  transform: scaleY(-1);
  transition: transform 0.3s ease;
}
.accordion-icon.expanded {
  transform: scaleY(1);
}

.accordion-icon-left {
  flex-shrink: 0;
  margin-right: var(--bsi-spacing-s, 0.5rem);
}

.accordion.accordion-left-icon .accordion-icon {
  display: none;
}

.accordion-header {
  display: flex;
}
.accordion-header .accordion-button {
  background-color: unset;
}`;

export { __decorate as _, __metadata as a, styles as s };
//# sourceMappingURL=accordion-DS_Nb4M5.js.map
